import Queue from './Queue';

class ActionsQueueService {
  constructor(actions = []) {
    this.queue = new Queue(actions); // Массив функций, возвращающих Promise
    this.isProcessing = false;
    this.finallyCallbacks = [];
  }

  add(...action) {
    this.queue.enqueue(...action);
  }

  execute(isRecursiveExecution = false, finallyCallback) {
    finallyCallback && this.finallyCallbacks.push(finallyCallback);

    return new Promise((resolve) => {
      if (!this.queue.isEmpty() && (!this.isProcessing || isRecursiveExecution)) {
        this.isProcessing = true;
        const currentAction = this.queue.dequeue();

        const promisedAction = currentAction();

        promisedAction.finally(() => {
          if (this.queue.isEmpty()) {
            this.isProcessing = false;
            this.finallyCallbacks.forEach(cb => cb());
            this.finallyCallbacks = [];
            resolve();
          } else {
            return resolve(this.execute(true));
          }
        });
      }
    });
  }

  stop() {
    this.queue = new Queue();
    this.isProcessing = false;
  }
}

export default ActionsQueueService;
